import Backbone from '@polleverywhere/backbone'
import store2 from 'store2'
import forceLogoutWhenParamExists from '../../util/force_logout_when_param_exists'
import { slice as appSlice } from '../../slices/app'
import store from '@polleverywhere/redux'

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      'code/:authCode': async (authCode) => {
        // Store the auth code temporarily
        store2.page.set('auth_code', authCode)

        // Let the user know we're doing something clever
        store.dispatch(appSlice.pageUpdated('please_wait'))

        // Force a logout if requested
        await forceLogoutWhenParamExists()

        // Redirect to the complete page - which is
        // defined as having `userRequired` which ensures the user is logged in first
        store.dispatch(appSlice.pageUpdated('out_of_band_complete'))
      },
      // Catch all
      '*args': () => {
        store.dispatch(appSlice.pageUpdated('not_found'))
      }
    }
  }

  initialize ({ state, updateURL = true } = {}) {
    this.state = state
  }
}
